import SubtitleService from "@/services/subtitle/subtitle.service";

export const subtitle = {
    namespaced: true,
    state: {
        subtitleURL: null,
        subtitleName: "",
        subtitleExists: false,
        sync: 0,
    },
    getters: {
        subtitleFiles: (state, getters, rootState) => {
            const mediaFile = rootState.media.mediaFile;

            // 공유 영상 여부에 따라 파일 목록 선택
            const files = mediaFile?.isShared
                ? rootState.share?.fileArray
                : rootState.files?.fileArray;

            return (files || []).filter(item => {
                if (!item.isFile) return false;

                const ext = item.name?.split(".").pop()?.toLowerCase();

                return ["vtt", "srt", "smi"].includes(ext);
            });
        }
    },
    mutations: {
        setSubtitleURL(state, url) {
            state.subtitleURL = url;
        },
        setSubtitleName(state, name) {
            state.subtitleName = name;
        },
        setSubtitleExists(state, value) {
            state.subtitleExists = value;
        },
        setSync(state, value) {
            state.sync = value;
        },
    },
    actions: {
        async selectSubtitle({ commit, dispatch }, name) {
            commit("setSubtitleName", name);
            commit("setSubtitleURL", null);
            commit("setSubtitleExists", false);

            return await dispatch("reloadSubtitle");
        },
        async reloadSubtitle({ state, commit, rootState }) {
            if (!state.subtitleName) {
                commit("setSubtitleURL", null);
                commit("setSubtitleExists", false);
                return false;
            }

            const mediaFile = rootState.media.mediaFile;

            const result = await SubtitleService.get(
                state.subtitleName,
                state.sync,
                mediaFile
            );

            if (!result) {
                commit("setSubtitleURL", null);
                commit("setSubtitleExists", false);
                return false;
            }

            commit("setSubtitleURL", result.url);
            commit("setSubtitleName", result.name);
            commit("setSubtitleExists", true);

            return true;
        },

        async adjustSync({ state, commit, dispatch }, ms) {
            commit("setSync", state.sync + ms);

            return await dispatch("reloadSubtitle");
        },

        async resetSync({ commit, dispatch }) {
            commit("setSync", 0);

            return await dispatch("reloadSubtitle");
        },
        async findSubtitle({ commit, rootState }, { file, sync = 0 }) {
            commit("setSubtitleExists", false);
            commit("setSubtitleName", "");
            commit("setSubtitleURL", "");
            commit("setSync", sync);

            if (!file) return false;

            const mediaFile = rootState.media.mediaFile;

            const result = await SubtitleService.find(
                file,
                sync,
                mediaFile
            );

            if (!result) {
                commit("setSubtitleURL", null);
                commit("setSubtitleExists", false);
                return false;
            }

            commit("setSubtitleURL", result.url);
            commit("setSubtitleName", result.name);
            commit("setSubtitleExists", true);

            return true;
        }
    },
};